import React, {useState, useContext, useEffect} from 'react'
import ReactStars from "react-rating-stars-component";
import { config } from '../server'
import {IsLoggedContext} from '../Store'
const address = config.url.API_URL

export default function Reviews(props) {
    const [rating, setRating] = useState(0)
    const [user] = useContext(IsLoggedContext)
    const tutor = props.match.params.tutor
    const [review, setReview] = useState(`${tutor} was so helpful...`)
    const [reviews, setReviews] = useState([])

  useEffect(() => {
    const getReviews = async () => {
      const res = await fetch(`${address}/api/${tutor}/reviews`)
      const data = await res.json()
      setReviews(data.allReviews)
    }

    getReviews()
  }, [tutor, reviews])

    const ratingChanged = (newRating) => {
        setRating(newRating)
      };

      const handleSubmit = async (event) => {
        event.preventDefault()
        const requestOptions = {
          method: 'POST',
          headers: { 
          'content-type': 'application/json' },
          body: JSON.stringify({ user: user, rating: rating, review: review, tutor: tutor})
        };
        const res = await fetch(address+'/api/review', requestOptions)
        const data = await res.json()
        if(data.status === 'exists') {
          alert('You already made a review')
        }
      } 

    return (
        <>
        <div className="heroContainer">
			Look at reviews for {tutor} or leave a review
        <div className='level-item'>
        <ReactStars
          count={5}
          onChange={ratingChanged}
          size={50}
          activeColor="#ffd700"
          value={rating}
          />
          <br/>        
          </div>
          <form onSubmit={handleSubmit}>
            <div className="level-item">
						<input style={{width: '50%'}}  className="input" onChange={e => setReview(e.target.value)} value={review} type="text" />
						</div>
            <input type='submit' value="Submit" className="blueBtn"/>
					</form>  
       </div>
       <div>
       {reviews.map((review, index) => (
         <div key={index}>
             
					<div key={JSON.stringify(review._id)} style={{paddingBottom: '2.5%'}}>
						<div key={index} className="spaceCard" style={{backgroundColor: '#F5F5F5', textAlign: 'center'}}>
							<div key={index} className="spaceCardText">
             
								<div key={index} className="spaceCardTitle level-item">
                <ReactStars
              count={5}
              size={50}
              edit={false}
              activeColor="#ffd700"
              value={review.rating}
              />
								</div>
                <p>{review.review}</p>	
							</div>
						</div>
					</div>
         </div>
       ))}
      </div>
        </>
    )
}